import React, { useRef, useState, useCallback, useEffect } from "react";
import { MoveLeft } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Dropdown,
  Button,
  Spinner,
  ToastContainer,
  Toast,
  Modal,
  Form,
} from "react-bootstrap";

import { Sidebar } from "../common/Sidebar";
import { Navbar } from "../common/Navbar";
import UserIcon from "../../assets/svg/user-blue.svg";
import mailIcon from "../../assets/svg/mail_grey.svg";
import phoneIcon from "../../assets/svg/phone_grey.svg";
import rejectedIcon from "../../assets/svg/rejected.svg";
import approvedIcon from "../../assets/svg/tick.svg";
import tickGreen from "../../assets/svg/tick_green.svg";
import wrongRed from "../../assets/svg/wrong_red.svg";
import requestImg from "../../assets/svg/request_img.svg";
import createdImg from "../../assets/svg/created_img.svg";
import {
  getPQViewDetailsApi,
  getVendorAddress,
  poConvertAPI,
  quotationStatusUpdateAPI,
} from "./pq-api";
import { apiCall } from "../../services/api-service.js";
import productIcon from "../../assets/svg/product_ic.svg";
import vendorIcon from "../../assets/svg/vendors.svg";
import productDefault from "../../assets/png/product_default.png";
import numberFormat from "../common/number-format";
import profileIc from "../../assets/png/profile-ic.png";
import ProfileImageModal from "../common/common-preview";
export const PurchaseQuotationView = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const adminUrl = process.env.REACT_APP_ADMIN_API_URL;

  const location = useLocation();
  const navigate = useNavigate();
  const from = location.state?.from;

  const [showApprovalModal, setShowApprovalModal] = useState(false);
  const [approvalAction, setApprovalAction] = useState("");
  const [approvalComments, setApprovalComments] = useState("");
  const [approvalCommentsMandatory, setApprovalCommentsMandatory] =
    useState(false);
  const handleBack = () => {
    if (from === "vendor") {
      navigate("/viewVendor", {
        state: {
          activeTab: "quotation",
          id: location.state?.vendorId,
        },
      });
    } else {
      navigate("/purchase-quotation");
    }
  };
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(null);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  const [negotiateIndex, setNegotiateIndex] = useState(null);
  const { id } = location.state || {};
  const [purchaseQuotation, setPurchaseQuotation] = useState({});
  const [isLoader, setIsLoader] = useState(false);
  const [isConvertLoader, setIsConvertLoader] = useState(false);
  const [isSubmitLoader, setIsSubmitLoader] = useState(-1);
  const [isRejectLoader, setIsRejectLoader] = useState(-1);
  const [isApproveLoader, setIsApproveLoader] = useState(-1);
  const [productList, setProductList] = useState([]);
  const [isEligibleApprover, setIsEligibleApprover] = useState(false);
  const [approvalHistory, setApprovalHistory] = useState([]);
  const [canReject, setCanReject] = useState(false);
  const [commentsMandatory, setCommentsMandatory] = useState(false);

  const fetchApprovalHistory = async (docId) => {
    try {
      const response = await apiCall("get", `approval_history/${docId}`, null, {
        params: { type: "purchase_quotation" },
      });
      if (response.data?.success) {
        const historyList = response.data.histories ?? [];
        setApprovalHistory(historyList);
        const isEligible = response.data.is_eligible ?? false;
        setIsEligibleApprover(isEligible);
        setCanReject(response.data.can_reject ?? false);
        setCommentsMandatory(response.data.comments_mandatory ?? false);
      }
    } catch (e) {
      console.error("Error fetching approval history", e);
    }
  };

  const handleApprovalActionClick = (action) => {
    if (action === "REJECT" && !canReject) {
      alert("Reject action is not allowed for this level.");
      return;
    }
    setApprovalAction(action);
    setApprovalComments("");
    setApprovalCommentsMandatory(commentsMandatory || action === "REJECT");
    setShowApprovalModal(true);
  };

  const handleApprovalAction = async () => {
    if (approvalCommentsMandatory && !approvalComments.trim()) {
      alert("Comment is required.");
      return;
    }

    setShowApprovalModal(false);
    setIsLoader(true);
    try {
      const response = await apiCall("post", "approval/action", {
        document_id: id,
        document_type: "purchase_quotation",
        action: approvalAction,
        comments: approvalComments,
      });
      if (response.data?.success) {
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(true);
        handleSnackbarShow();
        getPQViewDetails();
      } else {
        setSnackbarMessage(response.data?.message || "Action failed");
        setSnackbarStatus(false);
        handleSnackbarShow();
      }
    } catch (e) {
      console.error(e);
      setSnackbarMessage("An error occurred.");
      setSnackbarStatus(false);
      handleSnackbarShow();
    } finally {
      setIsLoader(false);
    }
  };
  useEffect(() => {
    if (id != null) {
      getPQViewDetails();
    }
  }, [id]);

  const [isIgst, setIsIgst] = useState(false);
  const [isCgst, setIsCgst] = useState(false);
  const [isSgst, setIsSgst] = useState(false);
  const getAddress = async (id) => {
    try {
      const response = await getVendorAddress(id);
      if (response.data.success === true) {
        setIsIgst(response.data.data.igst ?? false);
        setIsCgst(response.data.data.cgst ?? false);
        setIsSgst(response.data.data.sgst ?? false);
      }
    } catch (e) {}
  };
  const getPQViewDetails = async () => {
    try {
      const response = await getPQViewDetailsApi(id);

      if (response.data.success === true) {
        const pqDetail = response.data.quotation ?? {};
        setPurchaseQuotation(pqDetail);
        getAddress(pqDetail.vendor_id);
        if (pqDetail.approval_config_id) {
          fetchApprovalHistory(pqDetail.id);
        }
        /*  const updatedData = pqDetail.products.map((item) => ({
          ...item,

          quantity: 0,
          amount: 0,
        })); */
        setProductList(pqDetail.products ?? []);
      } else {
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getPQUpdateNegotiate = async (body) => {
    try {
      const response = await quotationStatusUpdateAPI(id, body);

      if (response.data.success === true) {
        setNegotiateIndex(-1);
        getPQViewDetails();
      } else {
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const updateConvertPO = async () => {
    if (isConvertLoader) return;
    try {
      setIsConvertLoader(true);
      const response = await poConvertAPI(id);

      if (response.data.success === true) {
        getPQViewDetails();

        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();
      } else {
      }
      return response.data;
    } catch (err) {
      setSnackbarMessage(
        err.response?.data?.message || err.message || "Something went wrong",
      );
      setSnackbarStatus(false);
      handleSnackbarShow();
      console.error("Error fetching category:", err);
    } finally {
      setIsConvertLoader(false);
    }
  };

  const calculateTotalAmount = (row) => {
    const unitPrice = Number(row["unit_without_tax"]);
    const quantity = Number(row["qty"]);
    const cgst = Number(row["cgst"]);
    const sgst = Number(row["sgst"]);
    const igst = Number(row["igst"]);

    const baseAmount = unitPrice * quantity;
    const taxAmount = baseAmount * ((cgst + sgst + igst) / 100);

    return (baseAmount + taxAmount).toFixed(2);
  };
  const [showProfilePopup, setShowProfilePopup] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState("");
  const [activeTab, setActiveTab] = useState("Purchase Details");
  return (
    <>
      <ProfileImageModal
        show={showProfilePopup}
        onClose={() => setShowProfilePopup(false)}
        imageUrl={selectedProfile}
      />
      <Modal
        show={showApprovalModal}
        onHide={() => setShowApprovalModal(false)}
        centered
        className="custom-modal"
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="fs-18 fw-600 textcolor">
            {approvalAction === "REJECT"
              ? "Reject Quotation"
              : "Approve Quotation"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-3">
          <Form.Group>
            <Form.Label className="fs-14 fw-500 textcolor mb-2">
              {approvalAction === "REJECT"
                ? "Enter reason for rejection"
                : "Enter comments"}
              {approvalCommentsMandatory && (
                <span className="text-danger"> *</span>
              )}
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={approvalComments}
              onChange={(e) => setApprovalComments(e.target.value)}
              placeholder="Type comments here..."
              className="fs-13 rounded-3"
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="border-0 pt-0">
          <Button
            variant="light"
            onClick={() => setShowApprovalModal(false)}
            className="rounded-3 px-3 py-1_5 fs-13 fw-500"
          >
            Cancel
          </Button>
          <Button
            variant={approvalAction === "REJECT" ? "danger" : "primary"}
            onClick={handleApprovalAction}
            disabled={approvalCommentsMandatory && !approvalComments.trim()}
            className="rounded-3 px-3 py-1_5 fs-13 fw-500"
            style={
              approvalAction !== "REJECT"
                ? { backgroundColor: "#2563EB", borderColor: "#2563EB" }
                : {}
            }
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
      <ToastContainer position="top-end">
        <Toast
          className="d-inline-block m-1"
          bg={snackbarStatus === true ? "success" : "danger"}
          show={showSnackbar}
          onClose={handleSnackbarClose}
          delay={3000}
          autohide
        >
          <Toast.Body style={{ color: "#ffffff" }}>
            {snackbarMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
      <div className="d-flex flex-column flex-xl-row">
        <Sidebar currentfile="Purchase Quotation" />
        <div className="w-100 bg-half-white" style={{ background: "#F5F8FA" }}>
          <Navbar pageTitle="Quotation" />
          <div>
            <div className="bg-white px-2 py-2 d-flex align-items-center justify-content-between">
              <div>
                <div className="style-justify-start gap-3 my-3">
                  <div
                    className="bg-white style-justify-center"
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "100px",
                      border: "1px solid #EBEBEB",
                    }}
                  >
                    <MoveLeft
                      className="cursor-pointer"
                      onClick={() => {
                        handleBack();
                      }}
                    />
                  </div>
                  <div
                    className="bg-white"
                    style={{
                      width: "52px",
                      height: "52px",
                      borderRadius: "100px",
                    }}
                  >
                    <img
                      src={purchaseQuotation.image ?? profileIc}
                      alt="product"
                      style={{
                        width: "64px",
                        height: "64px",
                        borderRadius: "100px",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedProfile(
                          purchaseQuotation.image &&
                            purchaseQuotation.image.trim() !== ""
                            ? purchaseQuotation.image
                            : profileIc,
                        );
                        setShowProfilePopup(true);
                      }}
                    />
                  </div>
                  <div className="ms-2">
                    <div className="fs-16 fw-400" style={{ color: "#212129" }}>
                      {purchaseQuotation.vendor_name ?? ""}
                    </div>

                    <div className="d-flex align-items-center gap-3 mt-2">
                      <div>
                        <img src={mailIcon} alt="mail" />{" "}
                        <span
                          className="ms-1 fs-13 fw-400"
                          style={{ color: "#8790A1" }}
                        >
                          {purchaseQuotation.email ?? ""}
                        </span>{" "}
                      </div>
                      <div className="border-start mx-1"></div>
                      <div>
                        <img src={phoneIcon} alt="mail" />{" "}
                        <span
                          className="ms-1 fs-13 fw-400"
                          style={{ color: "#8790A1" }}
                        >
                          {purchaseQuotation.mobile ?? ""}
                        </span>{" "}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="style-justify-start gap-3">
                  <div
                    className="m-0 rounded-pill px-2 py-1 d-flex gap-2 fs-13 fw-400"
                    style={{
                      backgroundColor: "#FFFFFF",
                      border: "1px solid #EBEBEB",
                    }}
                  >
                    <span className="fs-13 fw-400" style={{ color: "#515159" }}>
                      Request :
                    </span>
                    <span
                      className="ps-1 fs-13 fw-500"
                      style={{ color: "#4F46E5" }}
                    >
                      {purchaseQuotation.req_no ?? ""}
                    </span>
                  </div>

                  <div
                    className="m-0 rounded-pill px-2 py-1 d-flex gap-2 fs-13 fw-400"
                    style={{
                      backgroundColor: "#FFFFFF",
                      border: "1px solid #EBEBEB",
                    }}
                  >
                    <span className="fs-13 fw-400" style={{ color: "#515159" }}>
                      Quotation :
                    </span>
                    <span
                      className="ps-1 fs-13 fw-500"
                      style={{ color: "#4F46E5" }}
                    >
                      {purchaseQuotation.quotation_no ?? ""}
                    </span>
                  </div>

                  <div
                    className="m-0 rounded-pill px-2 py-1 d-flex gap-2 fs-13 fw-400"
                    style={{
                      backgroundColor: "#FFFFFF",
                      border: "1px solid #EBEBEB",
                    }}
                  >
                    <span className="fs-13 fw-400" style={{ color: "#515159" }}>
                      Validity :
                    </span>
                    <span
                      className="ps-1 fs-13 fw-500"
                      style={{ color: "#4F46E5" }}
                    >
                      {purchaseQuotation.validity_date ?? ""}
                    </span>
                  </div>
                </div>
              </div>
              <div className="d-flex gap-2 align-items-center">
                {isEligibleApprover && (
                  <div className="d-flex gap-2">
                    <Button
                      variant="success"
                      className="rounded-5 fs-13 fw-600 px-3"
                      style={{
                        height: "36px",
                        backgroundColor: "#10B981",
                        borderColor: "#10B981",
                      }}
                      onClick={() => handleApprovalActionClick("APPROVE")}
                    >
                      Approve
                    </Button>
                    {canReject && (
                      <Button
                        variant="danger"
                        className="rounded-5 fs-13 fw-600 px-3"
                        style={{
                          height: "36px",
                          backgroundColor: "#EF4444",
                          borderColor: "#EF4444",
                        }}
                        onClick={() => handleApprovalActionClick("REJECT")}
                      >
                        Reject
                      </Button>
                    )}
                  </div>
                )}
                {purchaseQuotation.po_status !== true &&
                  productList.some((item) => item.last_status === "Approve") &&
                  !productList.some(
                    (item) => item.last_status === "Pending",
                  ) && (
                    <Button
                      className={`cursor-pointer fs-14 fw-700 ${isLoader ? "disabled-btn" : ""} border-0 rounded-4  py-2 px-4 d-flex justify-content-center align-items-center`}
                      onClick={
                        isLoader === false
                          ? () => {
                              updateConvertPO();
                            }
                          : () => {}
                      }
                      style={{
                        minWidth: "108px",
                        background: "#4F46E5",
                      }}
                    >
                      {isConvertLoader ? (
                        <Spinner animation="border" size="sm" />
                      ) : (
                        "Convert to Po"
                      )}
                    </Button>
                  )}
              </div>
              {/*  <div className="d-flex gap-3">
              <Button
                className="cursor-pointer bg-white rounded-pill px-4 py-2  btn-border-grey fs-15 fw-500"
                style={{ border: "1px solid #D4DDE7", color: "#212129" }}
                onClick={() => {
                  navigate(-1);
                }}
              >
                Cancel
              </Button>
              <Button
                className={`cursor-pointer dark-purple-btn ${
                  isLoader ? "disabled-btn" : ""
                } rounded-pill py-2 px-4 d-flex justify-content-center align-items-center`}
                onClick={isLoader === false ? () => {} : () => {}}
                style={{ minWidth: "100px" }}
              >
                {isLoader ? (
                  <Spinner animation="border" size="sm" />
                ) : id != null ? (
                  "Update"
                ) : (
                  "Save"
                )}
              </Button>
            </div> */}
            </div>

            {/* Tabs Navigation */}
            <div className="d-flex align-items-center gap-3 px-3 mt-3 mb-2">
              {[
                { id: "Purchase Details", label: "Purchase Details" },
                { id: "Terms & Conditions", label: "Terms & Conditions" },
                {
                  id: "Approvals",
                  label: `Approval History (${approvalHistory?.length || 0})`,
                },
              ].map((tab) => {
                const isActive = activeTab === tab.id;
                return (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className="btn px-4 py-2 rounded-pill fw-600 fs-14 transition-all"
                    style={{
                      backgroundColor: isActive ? "#4F46E5" : "#FFFFFF",
                      color: isActive ? "#FFFFFF" : "#1F2937",
                      border: isActive ? "none" : "1px solid #E5E7EB",
                      boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
                    }}
                  >
                    {tab.label}
                  </button>
                );
              })}
            </div>

            {activeTab === "Purchase Details" ? (
              <div className="m-2 bg-white rounded-4 p-3">
                <div className="row">
                  <div className="col-12 ">
                    <div className="row">
                      <div className="col-xl-12">
                        <p className="fs-18 fw-600 mb-0">Quotation Details </p>
                      </div>
                      {productList.map((row, index) => (
                        <div
                          className="w-100 m-2 rounded-4 p-3"
                          style={{ background: "#F8F8F8" }}
                        >
                          <div className="style-justify-between">
                            <div className="style-justify-start">
                              <div
                                className="bg-white"
                                style={{
                                  width: "64px",
                                  height: "64px",
                                  borderRadius: "100px",
                                }}
                              >
                                <img
                                  src={
                                    row.image && row.image.trim() !== ""
                                      ? row.image
                                      : productDefault
                                  }
                                  alt="product"
                                  style={{
                                    width: "64px",
                                    height: "64px",
                                    borderRadius: "100px",
                                  }}
                                />
                              </div>

                              <div className="ms-2">
                                <div
                                  className="fs-16 fw-400"
                                  style={{ color: "#212129" }}
                                >
                                  {row.name ?? ""}
                                </div>

                                <div className="d-flex align-items-center gap-3 mt-2">
                                  <div
                                    className="m-0 rounded-pill px-2 py-1 d-flex gap-2 fs-13 fw-400"
                                    style={{ backgroundColor: "#EEEEEE" }}
                                  >
                                    <span
                                      className="fs-12 fw-400"
                                      style={{ color: "#212129" }}
                                    >
                                      Qty :
                                    </span>
                                    <span
                                      className="ps-1 fs-12 fw-500"
                                      style={{ color: "#4F46E5" }}
                                    >
                                      {numberFormat(row.qty ?? "0")}
                                    </span>
                                  </div>
                                  <div
                                    className="rounded-circle mx-1"
                                    style={{
                                      backgroundColor: "#D9D9D9",
                                      width: "4px",
                                      height: "4px",
                                    }}
                                  ></div>
                                  <div
                                    className="fs-13 fw-400"
                                    style={{ color: "#8790A1" }}
                                  >
                                    {row.code ?? ""}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="style-justify-end">
                              <div className="me-2">
                                <div
                                  className="fs-13 fw-500"
                                  style={{ color: "#212129", textAlign: "end" }}
                                >
                                  {row.user ?? ""}
                                </div>
                                <div
                                  className="fs-11 fw-400"
                                  style={{ color: "#8790A1", textAlign: "end" }}
                                >
                                  {row.last_update ?? ""}
                                </div>
                              </div>
                              <div
                                className="bg-white style-justify-center"
                                style={{
                                  width: "32px",
                                  height: "32px",
                                  borderRadius: "100px",
                                }}
                              >
                                <img src={UserIcon} alt="user" />
                              </div>
                            </div>
                          </div>
                          <div className="border-top my-3"></div>

                          {negotiateIndex === index && (
                            <div className="style-justify-start gap-3">
                              <div>
                                <div
                                  className="fs-12 fw-400  mb-1"
                                  style={{ color: "#8790A1" }}
                                >
                                  Unit without Tax
                                </div>
                                <div style={{ maxWidth: "158px" }}>
                                  <input
                                    type="text"
                                    className="form-control rounded-3 vendor-form-input"
                                    id={`unit_without_tax` + index}
                                    placeholder="Enter here"
                                    onChange={(e) => {
                                      var value = e.target.value.replace(
                                        /\D/g,
                                        "",
                                      );
                                      const productTemp = [...productList];
                                      productTemp[index]["unit_without_tax"] =
                                        value;
                                      setProductList(productTemp);
                                    }}
                                  />
                                </div>
                              </div>

                              {isCgst && (
                                <div>
                                  <div
                                    className="fs-12 fw-400  mb-1"
                                    style={{ color: "#8790A1" }}
                                  >
                                    CGST %
                                  </div>
                                  <div style={{ maxWidth: "80px" }}>
                                    <input
                                      type="number"
                                      className="form-control rounded-3 vendor-form-input"
                                      id={`tax_percentage` + index}
                                      placeholder="Enter here"
                                      onChange={(e) => {
                                        let inputValue = e.target.value.replace(
                                          /[^0-9.]/g,
                                          "",
                                        );
                                        let numericValue =
                                          parseFloat(inputValue);

                                        if (isNaN(numericValue)) {
                                          inputValue = "";
                                        } else if (numericValue > 100) {
                                          inputValue = "100"; // clamp to 100
                                        }
                                        const productTemp = [...productList];

                                        // productTemp[index]["tax_percentage"] = value;
                                        productTemp[index]["cgst"] = inputValue;
                                        setProductList(productTemp);
                                      }}
                                    />
                                  </div>
                                </div>
                              )}
                              {isIgst && (
                                <div>
                                  <div
                                    className="fs-12 fw-400  mb-1"
                                    style={{ color: "#8790A1" }}
                                  >
                                    IGST %
                                  </div>
                                  <div style={{ maxWidth: "80px" }}>
                                    <input
                                      type="number"
                                      className="form-control rounded-3 vendor-form-input"
                                      id={`tax_percentage` + index}
                                      placeholder="Enter here"
                                      onChange={(e) => {
                                        let inputValue = e.target.value.replace(
                                          /[^0-9.]/g,
                                          "",
                                        );
                                        let numericValue =
                                          parseFloat(inputValue);

                                        if (isNaN(numericValue)) {
                                          inputValue = "";
                                        } else if (numericValue > 100) {
                                          inputValue = "100"; // clamp to 100
                                        }

                                        const productTemp = [...productList];
                                        productTemp[index]["igst"] = inputValue;
                                        setProductList(productTemp);
                                      }}
                                    />
                                  </div>
                                </div>
                              )}
                              {isSgst && (
                                <div>
                                  <div
                                    className="fs-12 fw-400  mb-1"
                                    style={{ color: "#8790A1" }}
                                  >
                                    SGST %
                                  </div>
                                  <div style={{ maxWidth: "80px" }}>
                                    <input
                                      type="number"
                                      className="form-control rounded-3 vendor-form-input"
                                      id={`tax_percentage` + index}
                                      placeholder="Enter here"
                                      onChange={(e) => {
                                        let inputValue = e.target.value.replace(
                                          /[^0-9.]/g,
                                          "",
                                        );
                                        let numericValue =
                                          parseFloat(inputValue);

                                        if (isNaN(numericValue)) {
                                          inputValue = "";
                                        } else if (numericValue > 100) {
                                          inputValue = "100"; // clamp to 100
                                        }
                                        // var value = e.target.value.replace(/\D/g, "");
                                        const productTemp = [...productList];
                                        productTemp[index]["sgst"] = inputValue;
                                        setProductList(productTemp);
                                      }}
                                    />
                                  </div>
                                </div>
                              )}

                              {/* <div>
                            <div className="fs-12 fw-400  mb-1" style={{ color: "#8790A1" }}>
                              Total with Tax
                            </div>
                            <div style={{ maxWidth: "158px" }}>
                              <div
                                className="mx-2 ps-2 d-flex align-items-center"
                                style={{
                                  minWidth: "134px",
                                  height: "36px",
                                  borderRadius: "8px",
                                  background: "#F8F8F8",
                                  border: "1px solid #EBEBEB",
                                }}
                              >
                                {Number(productList[index]["unit_without_tax"] ?? 0) + (Number(productList[index]["unit_without_tax"] ?? 0) * Number(productList[index]["tax_percentage"] ?? 0)) / 100}
                              </div>
                            </div>
                          </div> */}

                              {/* <div>
                          <div
                            className="fs-12 fw-400  mb-1"
                            style={{ color: "#8790A1" }}
                          >
                            Shipping Charges
                          </div>
                          <div style={{ maxWidth: "158px" }}>
                            <input
                              type="text"
                              className="form-control rounded-3 vendor-form-input"
                              id={`Amount` + index}
                              placeholder="Enter here"
                              onChange={(e) => {
                                var value = e.target.value.replace(/\D/g, "");
                                const productTemp = [...productList];
                                productTemp[index]["amount"] = value;
                                setProductList(productTemp);
                              }}
                            />
                          </div>
                        </div> */}

                              <div>
                                <div
                                  className="fs-12 fw-400 mb-1"
                                  style={{ color: "#8790A1" }}
                                >
                                  Total Amount
                                </div>
                                <div style={{ maxWidth: "158px" }}>
                                  <div
                                    className="mx-2 ps-2 d-flex align-items-center"
                                    style={{
                                      minWidth: "134px",
                                      height: "36px",
                                      borderRadius: "8px",
                                      background: "#F8F8F8",
                                      border: "1px solid #EBEBEB",
                                    }}
                                  >
                                    {/* {calculateTotalAmount(productList[index])} */}
                                    {Number(
                                      productList[index]["unit_without_tax"] ??
                                        0,
                                    ) *
                                      Number(productList[index]["qty"] ?? 0) +
                                      (Number(
                                        productList[index][
                                          "unit_without_tax"
                                        ] ?? 0,
                                      ) *
                                        Number(productList[index]["qty"] ?? 0) *
                                        (Number(
                                          productList[index]["cgst"] ?? 0,
                                        ) +
                                          Number(
                                            productList[index]["sgst"] ?? 0,
                                          ) +
                                          Number(
                                            productList[index]["igst"] ?? 0,
                                          ))) /
                                        100}

                                    {/* {Number(productList[index]["unit_without_tax"] ?? 0) * Number(productList[index]["qty"] ?? 0) + (Number(productList[index]["unit_without_tax"] ?? 0) * Number(productList[index]["qty"] ?? 0) * (Number(productList[index]["cgst"] ?? 0) * Number(productList[index]["sgst"] ?? 0) * Number(productList[index]["igst"] ?? 0))) / 100} */}
                                  </div>
                                </div>
                              </div>

                              <div>
                                <div className="style-justify-start gap-2">
                                  <Button
                                    className={`cursor-pointer fs-14 fw-700   ${isLoader ? "disabled-btn" : ""} border-0 rounded-2  py-2 px-4 d-flex justify-content-center align-items-center`}
                                    onClick={
                                      isLoader === false
                                        ? () => {
                                            const productTemp = [
                                              ...productList,
                                            ];
                                            // productTemp[index]["is_negotiate"] = -1;
                                            setNegotiateIndex(-1);
                                            setProductList(productTemp);
                                          }
                                        : () => {}
                                    }
                                    style={{
                                      minWidth: "100px",
                                      color: "#212129",
                                      background: "#FFFFFF",
                                    }}
                                  >
                                    {isLoader ? (
                                      <Spinner animation="border" size="sm" />
                                    ) : (
                                      "Cancel"
                                    )}
                                  </Button>

                                  <Button
                                    className={`cursor-pointer fs-14 fw-700 ${isLoader ? "disabled-btn" : ""} border-0 rounded-2  py-2 px-4 d-flex justify-content-center align-items-center`}
                                    onClick={() => {
                                      if (isSubmitLoader === index) return; // ⛔ prevent double click

                                      setIsSubmitLoader(index);

                                      const payload = {
                                        products: [
                                          {
                                            id: row.id,
                                            status: "Negotiate",
                                            unit_without_tax:
                                              productList[index]
                                                ?.unit_without_tax ?? 0,
                                            cgst: productList[index]?.cgst ?? 0,
                                            sgst: productList[index]?.sgst ?? 0,
                                            igst: productList[index]?.igst ?? 0,
                                          },
                                        ],
                                      };

                                      getPQUpdateNegotiate(payload).finally(
                                        () => {
                                          setIsSubmitLoader(null); // ✅ reset loader
                                        },
                                      );
                                    }}
                                    style={{
                                      minWidth: "108px",
                                      color: "#FFFFFF",
                                      background: "#4F46E5",
                                    }}
                                  >
                                    {isSubmitLoader === index ? (
                                      <Spinner animation="border" size="sm" />
                                    ) : (
                                      "Submit"
                                    )}
                                  </Button>
                                </div>
                              </div>
                            </div>
                          )}

                          {row.history.map((historyRow, hisindex) => (
                            <div className="style-justify-start gap-3 mt-2 align-items-center">
                              <div className="bg-white rounded-4 p-2 align-items-center">
                                <div
                                  className="fs-12 fw-400"
                                  style={{
                                    color: "#8790A1",
                                    minWidth: "150px",
                                  }}
                                >
                                  Unit price
                                </div>
                                <div
                                  className="fs-14 fw-500"
                                  style={{
                                    color: "#212129",
                                    minWidth: "150px",
                                  }}
                                >
                                  {numberFormat(
                                    historyRow.unit_without_tax ?? "0",
                                  )}
                                </div>
                              </div>

                              {isCgst && (
                                <div className="bg-white rounded-4 p-2">
                                  <div
                                    className="fs-12 fw-400"
                                    style={{
                                      color: "#8790A1",
                                      minWidth: "60px",
                                    }}
                                  >
                                    CGST (%)
                                  </div>
                                  <div
                                    className="fs-14 fw-500"
                                    style={{ color: "#212129" }}
                                  >
                                    {historyRow.cgst_percentage ?? "0"}
                                  </div>
                                </div>
                              )}
                              {isIgst && (
                                <div className="bg-white rounded-4 p-2">
                                  <div
                                    className="fs-12 fw-400"
                                    style={{
                                      color: "#8790A1",
                                      minWidth: "60px",
                                    }}
                                  >
                                    IGST (%)
                                  </div>
                                  <div
                                    className="fs-14 fw-500"
                                    style={{ color: "#212129" }}
                                  >
                                    {historyRow.igst_percentage ?? "0"}
                                  </div>
                                </div>
                              )}
                              {isSgst && (
                                <div className="bg-white rounded-4 p-2">
                                  <div
                                    className="fs-12 fw-400"
                                    style={{
                                      color: "#8790A1",
                                      minWidth: "60px",
                                    }}
                                  >
                                    SGST (%)
                                  </div>
                                  <div
                                    className="fs-14 fw-500"
                                    style={{ color: "#212129" }}
                                  >
                                    {historyRow.sgst_percentage ?? "0"}
                                  </div>
                                </div>
                              )}

                              {/* <div className="bg-white rounded-4 p-2">
                            <div className="fs-12 fw-400" style={{ color: "#8790A1", minWidth: "150px" }}>
                              Unit Price with Tax
                            </div>
                            <div className="fs-14 fw-500" style={{ color: "#212129" }}>
                              {historyRow.unit_with_tax ?? "0"}
                            </div>
                          </div> */}

                              {/* <div className="bg-white rounded-4 p-3">
                          <div
                            className="fs-12 fw-400"
                            style={{ color: "#8790A1" }}
                          >
                            Shipping Charges
                          </div>
                          <div
                            className="fs-14 fw-500"
                            style={{ color: "#212129" }}
                          >
                            ₹2000
                          </div>
                        </div> */}

                              <div className="bg-white rounded-4 p-2">
                                <div
                                  className="fs-12 fw-400"
                                  style={{
                                    color: "#8790A1",
                                    minWidth: "150px",
                                  }}
                                >
                                  Total Amount
                                </div>
                                <div
                                  className="fs-14 fw-500"
                                  style={{ color: "#212129" }}
                                >
                                  {numberFormat(historyRow.total_amount ?? "0")}
                                </div>
                              </div>
                              {/* <div className="bg-white rounded-4 p-2">
                            <div className="fs-12 fw-400" style={{ color: "#8790A1", minWidth: "60px" }}>
                              TDS (%)
                            </div>
                            <div className="fs-14 fw-500" style={{ color: "#212129" }}>
                              {historyRow.tds_percentage ?? "0"}
                            </div>
                          </div> */}

                              <div>
                                {historyRow.status === "Pending" &&
                                  purchaseQuotation.status === "Approved" &&
                                  negotiateIndex !== index && (
                                    <div className="style-justify-start gap-2">
                                      <Button
                                        className={`cursor-pointer fs-14 fw-700 border-0 rounded-2 py-2 px-4
    d-flex justify-content-center align-items-center
    ${isRejectLoader === index ? "disabled-btn" : ""}`}
                                        onClick={() => {
                                          if (isRejectLoader === index) return; // ⛔ prevent double click

                                          setIsRejectLoader(index);

                                          const payload = {
                                            products: [
                                              {
                                                id: row.id,
                                                status: "Reject",
                                              },
                                            ],
                                          };

                                          getPQUpdateNegotiate(payload).finally(
                                            () => {
                                              setIsRejectLoader(-1); // ✅ reset loader
                                            },
                                          );
                                        }}
                                        style={{
                                          minWidth: "84px",
                                          background: "#FF4444",
                                          opacity:
                                            isRejectLoader === index ? 0.7 : 1,
                                          pointerEvents:
                                            isRejectLoader === index
                                              ? "none"
                                              : "auto",
                                        }}
                                      >
                                        {isRejectLoader === index ? (
                                          <Spinner
                                            animation="border"
                                            size="sm"
                                          />
                                        ) : (
                                          "Reject"
                                        )}
                                      </Button>

                                      <Button
                                        className={`cursor-pointer fs-14 fw-700 border-0 rounded-2 py-2 px-4
    d-flex justify-content-center align-items-center
    ${isApproveLoader === index ? "disabled-btn" : ""}`}
                                        onClick={() => {
                                          if (isApproveLoader === index) return; // ⛔ prevent double click

                                          setIsApproveLoader(index);

                                          const payload = {
                                            products: [
                                              {
                                                id: row.id,
                                                status: "Approve",
                                              },
                                            ],
                                          };

                                          getPQUpdateNegotiate(payload).finally(
                                            () => {
                                              setIsApproveLoader(-1); // ✅ reset loader
                                            },
                                          );
                                        }}
                                        style={{
                                          minWidth: "100px",
                                          background: "#4EBD7E",
                                          opacity:
                                            isApproveLoader === index ? 0.7 : 1,
                                          pointerEvents:
                                            isApproveLoader === index
                                              ? "none"
                                              : "auto",
                                        }}
                                      >
                                        {isApproveLoader === index ? (
                                          <Spinner
                                            animation="border"
                                            size="sm"
                                          />
                                        ) : (
                                          "Approve"
                                        )}
                                      </Button>

                                      <Button
                                        className={`cursor-pointer fs-14 fw-700 ${isLoader ? "disabled-btn" : ""} border-0 rounded-2  py-2 px-4 d-flex justify-content-center align-items-center`}
                                        onClick={
                                          isLoader === false
                                            ? () => {
                                                const productTemp = [
                                                  ...productList,
                                                ];

                                                // productTemp[index]["is_negotiate"] = index;
                                                setNegotiateIndex(index);
                                                setProductList(productTemp);
                                              }
                                            : () => {}
                                        }
                                        style={{
                                          minWidth: "108px",
                                          background: "#4F46E5",
                                        }}
                                      >
                                        {isLoader ? (
                                          <Spinner
                                            animation="border"
                                            size="sm"
                                          />
                                        ) : (
                                          "Negotiate"
                                        )}
                                      </Button>
                                    </div>
                                  )}
                                {historyRow.status === "Approve" && (
                                  <div
                                    className="fs-14 fw-500"
                                    style={{ color: "#4F46E5" }}
                                  >
                                    <img
                                      src={approvedIcon}
                                      alt="approvedIcon"
                                    />{" "}
                                    <span
                                      className="fs-14 fw-500"
                                      style={{ color: "#17B65B" }}
                                    >
                                      Quotation Accepted
                                    </span>
                                  </div>
                                )}
                                {historyRow.status === "Reject" && (
                                  <div
                                    className="fs-14 fw-500"
                                    style={{ color: "#4F46E5" }}
                                  >
                                    <img
                                      src={rejectedIcon}
                                      alt="rejectedIcon"
                                    />{" "}
                                    <span
                                      className="fs-14 fw-500"
                                      style={{ color: "#FF4444" }}
                                    >
                                      Quotation Rejected
                                    </span>
                                  </div>
                                )}
                                {historyRow.status === "Negotiate" && (
                                  <div
                                    className="fs-14 fw-500"
                                    style={{ color: "#4F46E5" }}
                                  >
                                    Negotiated on {historyRow.last_update ?? ""}
                                  </div>
                                )}
                              </div>
                            </div>
                          ))}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ) : activeTab === "Terms & Conditions" ? (
              <div className="m-2 d-flex flex-column gap-3">
                {/* Card 1: Terms Details */}
                <div
                  className="bg-white rounded-4 p-4"
                  style={{
                    border: "1px solid #EBEBEB",
                    boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.04)",
                  }}
                >
                  {[
                    {
                      title: "Payment Terms",
                      desc: purchaseQuotation.payment_terms || "Not provided",
                    },
                    {
                      title: "Inco Terms",
                      desc: purchaseQuotation.inco_terms || "Not provided",
                    },
                    {
                      title: "Notes & Instructions",
                      desc:
                        purchaseQuotation.note_instruction || "Not provided",
                    },
                    {
                      title: "Terms & Conditions",
                      desc: purchaseQuotation.term_conditions || "Not provided",
                    },
                  ].map((item, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        minHeight: "66px",
                        gap: "12px",
                        paddingTop: index > 0 ? "16px" : "0px",
                        paddingBottom: index < 3 ? "16px" : "0px",
                        borderTop: index > 0 ? "1px solid #F3F4F6" : "none",
                      }}
                    >
                      <h6
                        className="fw-600 mb-0"
                        style={{
                          fontFamily: "'Lexend Deca', sans-serif",
                          fontSize: "14px",
                          color: "#1F2937",
                        }}
                      >
                        {item.title}
                      </h6>
                      <div
                        className="mb-0"
                        style={{
                          fontFamily: "'Lexend Deca', sans-serif",
                          fontSize: "13px",
                          fontWeight: "400",
                          color: "#4B5563",
                          lineHeight: "1.6",
                        }}
                        dangerouslySetInnerHTML={{
                          __html: item.desc.replace(/\n/g, "<br/>"),
                        }}
                      />
                    </div>
                  ))}
                </div>

                {/* Card 2: Authorized Signature */}
                <div
                  className="bg-white rounded-4 p-4"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    minHeight: "121px",
                    height: "121px",
                    gap: "12px",
                    border: "1px solid #EBEBEB",
                    boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.04)",
                  }}
                >
                  <h6
                    className="fw-600 mb-0"
                    style={{
                      fontFamily: "'Lexend Deca', sans-serif",
                      fontSize: "14px",
                      color: "#1F2937",
                    }}
                  >
                    Authorized Signature
                  </h6>
                  <div className="d-flex align-items-center justify-content-start">
                    {purchaseQuotation.authorized_signature ? (
                      <img
                        src={purchaseQuotation.authorized_signature}
                        alt="Authorized Signature"
                        style={{
                          maxHeight: "55px",
                          marginTop: "-10px",
                          objectFit: "contain",
                        }}
                      />
                    ) : (
                      <span
                        style={{
                          fontFamily: "'Lexend Deca', sans-serif",
                          fontSize: "13px",
                          color: "#9CA3AF",
                        }}
                      >
                        Not provided
                      </span>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              <div
                className="m-2 bg-white rounded-4 p-4"
                style={{
                  border: "1px solid #EBEBEB",
                  boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.04)",
                }}
              >
                <h5
                  className="fw-600 mb-4"
                  style={{
                    fontFamily: "'Lexend Deca', sans-serif",
                    fontSize: "16px",
                    color: "#1F2937",
                  }}
                >
                  Approval History
                </h5>

                {approvalHistory && approvalHistory.length > 0 ? (
                  <div className="position-relative ps-1">
                    {approvalHistory.map((h, idx) => {
                      let icon = tickGreen;
                      let bgLabelColor = "#E6FFF1";
                      let textLabelColor = "#10B981";

                      if (h.status === "Rejected") {
                        icon = wrongRed;
                        bgLabelColor = "#FEE2E2";
                        textLabelColor = "#EF4444";
                      } else if (h.status === "Requested") {
                        icon = requestImg;
                        bgLabelColor = "#DBEAFE";
                        textLabelColor = "#2563EB";
                      } else if (h.status === "Created") {
                        icon = createdImg;
                        bgLabelColor = "#F3F4F6";
                        textLabelColor = "#4B5563";
                      } else if (h.status === "Waiting for approval...") {
                        icon = tickGreen;
                        bgLabelColor = "#F3F4F6";
                        textLabelColor = "#4B5563";
                      }

                      return (
                        <div
                          key={idx}
                          className="d-flex align-items-start position-relative mb-4"
                          style={{ zIndex: 1 }}
                        >
                          {/* Vertical Dashed Line */}
                          {idx !== approvalHistory.length - 1 && (
                            <div
                              style={{
                                position: "absolute",
                                left: "16px",
                                top: "22px",
                                height: "calc(100% + 24px)",
                                width: "2px",
                                borderLeft: "2px dashed #D1D5DB",
                                zIndex: 0,
                              }}
                            ></div>
                          )}

                          <div
                            className="me-3"
                            style={{ zIndex: 2, marginTop: "6px" }}
                          >
                            <img
                              src={icon}
                              alt={h.status}
                              style={{ width: "32px", height: "32px" }}
                            />
                          </div>
                          <div className="d-flex flex-column gap-1">
                            <div className="d-flex align-items-center gap-2">
                              <span
                                className="fw-600"
                                style={{
                                  fontFamily: "'Lexend Deca', sans-serif",
                                  fontSize: "14px",
                                  color: "#1F2937",
                                }}
                              >
                                {h.status}
                              </span>
                              <span style={{ color: "#9CA3AF" }}>·</span>
                              <span
                                style={{
                                  fontFamily: "'Lexend Deca', sans-serif",
                                  fontSize: "12px",
                                  fontWeight: "500",
                                  backgroundColor: bgLabelColor,
                                  color: textLabelColor,
                                  padding: "2px 8px",
                                  borderRadius: "4px",
                                }}
                              >
                                {h.user_name}
                              </span>
                            </div>
                            {h.comments && (
                              <span
                                style={{
                                  fontFamily: "'Lexend Deca', sans-serif",
                                  fontSize: "13px",
                                  color: "#4B5563",
                                }}
                              >
                                {h.comments}
                              </span>
                            )}
                            <span
                              style={{
                                fontFamily: "'Lexend Deca', sans-serif",
                                fontSize: "12px",
                                color: "#9CA3AF",
                              }}
                            >
                              {h.date_time}
                            </span>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className="text-center py-4 text-muted">
                    No approval history found.
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
